<template>
  <div
    id="form-profile-popover"
    class="jNavBarApp container-navbar-home">
    <b-row class="navbar navbar-white navbar-expand-lg fixed-top">
      <b-col
        md="11"
        style="display: flex; align-content: center;">
        <div>
          <img
            src="@/assets/image/logo-navbar.png"
            height="30">
        </div>
        <div class="text-application-detail m__l--15 m__t--8">
          SIM SMKN 1 MAJALENGKA
        </div>
      </b-col>
      <div
        id="profileUser"
        style="display: flex; align-content: center; margin-right: 10px"
        class="cursor-pointer">
        <div>
          <img
            v-if="img"
            :src="img"
            class="round-bordered-img-small">
          <div
            v-else
            class="img-responsive-nav round-bordered-img-nav"/>
        </div>
        <img
          src="@/assets/image/vector.png"
          height="10"
          class="m__l--10 m__t--10">
      </div>
    </b-row>

    <b-popover
      ref="profileNavbar"
      :show.sync="popoverProfileShow"
      container="form-profile-popover"
      target="profileUser"
      placement="bottom">
      <b-row style="width: 225px; padding-left: 15px">
        <b-col
          md="3"
          class="p__l--1 p__r--1">
          <img
            v-if="img"
            :src="img"
            class="round-bordered-img-small-popover">
          <div
            v-else
            class="img-responsive-nav round-bordered-img-nav on-popover"/>
        </b-col>
        <b-col
          md="9"
          class="p__r--1">
          {{ name }}
          <div
            class="label-edit-profile"
            @click="editProfile">Edit Profile</div>
        </b-col>
      </b-row>
      <div class="hr-profile" />
      <div
        class="cursor-pointer"
        @click="logout">
        <img
          src="@/assets/image/logout.png"
          height="10">
        Logout
      </div>
    </b-popover>
  </div>
</template>

<script>
/* eslint-disable import/no-unresolved,vue/name-property-casing */

export default {
  name: 'jNavbarHomeSiswa',
  components: {
  },
  props: {
    user: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      name: localStorage.getItem('nama_siswa'),
      img: localStorage.getItem('photo'),
      id: localStorage.getItem('id'),

      popoverProfileShow: false,
    };
  },
  computed: {
  },
  methods: {
    logout() {
      this.$router.replace('/logout');
    },
    openSidebar() {
      // this.$store.dispatch('jStoreSetting/toogleSidebar', true);
    },
    editProfile() {
      // this.$router.replace(`/update-profile/${this.pegawai_id}/user`);
    },
  },
};
</script>

<style scoped>
  .img-responsive-nav {
    display: block;
    max-width: 100%;
  }

  .round-bordered-img-nav {
    float: left!important;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    background-image: url('../../assets/image/profile-new.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 30px 30px;
  }

  .on-popover {
    width: 50px !important;
    height: 50px !important;
    background-size: 50px 50px !important;
  }

  .label-edit-profile {
    background: #F0F7FF;
    border-radius: 22px;
    width: max-content;
    font-family: 'Gotham-Medium';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 15px;
    color: #2C8BFF;
    padding: 5px;
    cursor: pointer;
  }

  .hr-profile {
    margin: 10px 0px 10px 0px;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
</style>



// WEBPACK FOOTER //
// src/layouts/navbar/jNavbarHomeSiswa.vue